var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { loadModules } from "esri-loader";
import axios from "axios";
function createToken(clientId, clientSecret) {
    return __awaiter(this, void 0, void 0, function* () {
        const axiosConfig = {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        };
        const authServiceUrl = "https://nswses.maps.arcgis.com/sharing/rest/oauth2/token/";
        const formData = new FormData();
        formData.append("client_id", clientId);
        formData.append("client_secret", clientSecret);
        formData.append("grant_type", "client_credentials");
        try {
            const { data } = yield axios.post(authServiceUrl, formData, axiosConfig);
            return data.access_token;
        }
        catch (e) {
            throw e;
        }
    });
}
export default {
    authenticate(clientId, clientSecret) {
        return loadModules(["esri/identity/IdentityManager"])
            .then(([IdentityManager]) => {
            return createToken(clientId, clientSecret)
                .then(token => {
                const appToken = {
                    server: "https://nswses.maps.arcgis.com/sharing/rest",
                    token
                };
                IdentityManager.registerToken(appToken);
                return token;
            })
                .catch(err => {
                console.error(err);
            });
        })
            .catch(err => {
            console.error(err);
        });
    }
};
